'use strict';

var angular = require('angular');
module.exports = angular.module('AVRO.Widgets.Datepicker', ['AVRO.Common.Moment']).directive('rmDatepicker', require('./directives/DatepickerDirective'));